import { CreateTemplateInterface } from "../interfaces/TemplateInterfaces/CreateTemplate";
import { TemplateInterface } from "../interfaces/TemplateInterfaces/Template";
import BaseService from "./BaseService";

export class TemplateService extends BaseService<TemplateInterface, CreateTemplateInterface>{ 
    constructor(){
        let url: string = '/template/admin'
        super(url)
    }
}